'use client';

import Script from 'next/script';
import { useSearchParams } from 'next/navigation';
import { AppConfig } from '@/utils/AppConfig';

enum MeilisearchIndexes {
  CLUBS = 'ffbbserver_organismes',
  COMPETITIONS = 'ffbbserver_rencontres',
  PRATIQUES = 'ffbbnational_pratiques',
  PRATIQUE_LOCATIONS = 'ffbbserver_lieux',
  TOURNAMENTS = 'ffbbserver_tournois',
}
/**
 * 
 * Exemples de liens pour les différentes recherches :
 * /trouver?type=clubs&organismeType[]=Ligue&organismeType[]=Comité
 * /trouver?type=competitions&rencontreGenre[]=Féminin
 * /trouver?type=clubs&organismePratiques[]=Basket%20Inclusif (BaskeTonik, Basket%20Santé, Basket%20Inclusif ...)
 * /trouver?type=clubs&organismeLabels[]=Basket Inclusif (Basket Inclusif, Basket Santé / Résolutions, Label FFBB Citoyen MAIF 1 étoile, Label FFBB Citoyen MAIF 2 étoiles, Label FFBB Citoyen MAIF 3 étoiles, Label FFBB Citoyen MAIF 4 étoiles, Label FFBB Citoyen MAIF 5 étoiles)
 * /trouver?type=competitions&rencontreNiveau[]=International (International, National, Régional, Départemental)
 * /trouver?type=competitions&rencontreCategorie[]=SE (SE, U18, U15, U13, U11, U9, U7)
 * /trouver?type=tournois&tournoisType[]=Open Plus (Open Plus, Open Start)
 * /trouver?type=tournois&tournoiCategorie[]=junior (junior, senior)
 * /trouver?type=tournois&tournoiSexe[]=junior (junior, senior)
 * /trouver?type=tournois&tournoiSexe[]=Mixte (Mixte, senior)
 * 
 */
export default function FindWidget() {
  const searchParams = useSearchParams();

  const type = searchParams.get('type') || '';

  let selectedIndex = '';
  switch (type) {
    case 'clubs': {
      selectedIndex = MeilisearchIndexes.CLUBS;
      break;
    }
    case 'competitions': {
      selectedIndex = MeilisearchIndexes.COMPETITIONS;
      break;
    }
    case 'lieux_de_pratiques': {
      selectedIndex = MeilisearchIndexes.PRATIQUE_LOCATIONS;
      break;
    }
    case 'pratiques': {
      selectedIndex = MeilisearchIndexes.PRATIQUES;
      break;
    }
    case 'tournois': {
      selectedIndex = MeilisearchIndexes.TOURNAMENTS;
      break;
    }
  }

  let searchFilter:any = {}
  let paramsSearch = [
    { key: 'organismePratiques', value: 'offresPratiques' },
    { key: 'organismeType', value: 'type' },
    { key: 'organismeLabels', value: 'labellisation'},
    { key: 'rencontreNiveau', value: 'niveau'},
    { key: 'rencontreGenre', value: 'competitionId.sexe' },
    { key: 'rencontreCategorie', value: 'competitionId.categorie.code'},
    { key: 'tournoiType', value: 'tournoiType'},
    { key: 'tournoiCategorie', value: 'tournoiTypes3x3.type_league'},
    { key: 'tournoiSexe', value: 'sexe'},
    { key: 'pratiqueType', value: 'type'},
    { key: 'pratiqueLabel', value: 'label'},
  ];
  for (const param of paramsSearch) {
    let value = searchParams.getAll(param.key+'[]') || '';
    if (value.length === 0) {
      value = searchParams.getAll(param.key) || '';
    }
    if (value.length > 0) {
      searchFilter[param.value] = value;
    }
  }
  
  searchFilter = JSON.stringify(searchFilter);
  return (
    <div className="flex w-full">
      <div
        id="ffbb_widget_search"
        className={`h-[calc(100vh-100px)] md:h-[calc(100vh-153px)] min-h-[450px] w-full`}
        data-hub-config={JSON.stringify({ logo_url: '/', nologo: true})}
        data-index-selected={selectedIndex}
        data-query-origin=""
        data-query-refinements={`${searchFilter}`}
      ></div>
      <Script
        src={AppConfig.findWidgetUrl} 
        strategy="lazyOnload"
        onReady={() => {window.refreshFFBBwidget()}}
      />
    </div>
  );
}
